module.exports = __webpack_public_path__ + "static/media/445804873_461352426486702_3877303039485216870_n.65fa2ee6.jpg";